import { useState } from "react";
import { useQuery } from "@tanstack/react-query";

import { useCreateCause, useEditCause } from "../mutation";
import { raiseRiskApi } from "../api/raiseRiskApi";

export const useCause = ({ riskId, refetch }: { riskId: string | null, refetch: () => void }) => {

    const createCause = useCreateCause();
    const editCause = useEditCause();

    const { data: causeData, isFetching: isCauseFetching, isPending: isCausePending, refetch: refetchCauses } = useQuery({
        queryKey: ["project-risk-cause", riskId,],
        queryFn: () => raiseRiskApi.fetchCauses({ riskId: String(riskId) }),
        enabled: !!riskId
    });

    const [openCause, setOpenCause] = useState(false);

    const [causesData, setCausesData] = useState<{
        causeTitle: null | string
        causeDescription: null | string
        causeStatus: null | string
    }>({
        causeTitle: null,
        causeDescription: null,
        causeStatus: null,
    });

    const [editCauseStatus, setEditCauseStatus] = useState<{
        editCauseStatus: boolean
        causeId: string | null
    }>({
        editCauseStatus: false,
        causeId: null
    });

    const onSaveCause = async () => {
        const payload = {
            "title": causesData.causeTitle,
            "description": causesData.causeDescription,
            "status": causesData.causeStatus
        };
        if (editCauseStatus.editCauseStatus) {
            await editCause.mutateAsync({ riskId: String(riskId), causeId: editCauseStatus.causeId!, data: payload });
        } else {
            await createCause.mutateAsync({ riskId: String(riskId), data: payload });
        };
        await refetchCauses();
        onClearCause();
        refetch();
    };

    const onEditCause = async (data: any) => {
        setOpenCause(true);
        setEditCauseStatus({
            editCauseStatus: true,
            causeId: data.id
        });
        setCausesData({
            causeTitle: data.title,
            causeDescription: data.description,
            causeStatus: data.status
        });
    };

    const onClearCause = async () => {
        setOpenCause(false);
        setEditCauseStatus({
            editCauseStatus: false,
            causeId: null
        });
        setCausesData({
            causeTitle: null,
            causeDescription: null,
            causeStatus: null,
        });
    };

    return {
        openCause, setOpenCause,
        causesData, setCausesData,
        editCauseStatus, onSaveCause, onEditCause, onClearCause,
        causeData: causeData?.data?.rows, isCauseFetching, isCausePending, refetchCauses,
        isSaving: createCause.isPending || editCause.isPending
    };

};